import React, { memo } from 'react';
import styles from './style.module.css';

const FormHeader = (props) => {
  const { heading, subHeading } = props;

  return (
    <>
      <h1 className={styles.form_heading} data-test="form-heading">
        {heading}
      </h1>
      <p className={styles.form_subheading} data-test="form-sub-heading">
        {subHeading}
      </p>
    </>
  );
};

export default memo(FormHeader);
